import { styled } from 'styled-components'
import { motion } from 'motion/react'
import { SlideInDirection } from '../components/SlideInMotion'

export const StyledPicContainer = styled.div`
  font-size: 26px;
  margin: 1.1rem auto 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(240px, 1fr));
  gap: 1rem;

  @media (max-width: ${({ theme }) => theme.screen.small}) {
    grid-template-columns: 1fr;
    gap: 0.8rem;
  }
`

export const StyledPicItem = styled.div`
  width: 100%;
  max-width: 420px;
  padding: 1rem 1rem 1.2rem;
  margin: 0 auto;
  border-radius: 22px;
  border: 1px solid ${({ theme }) => theme.colors.border.soft};
  background: ${({ theme }) => theme.colors.surface.base};
  box-shadow: 0 16px 28px ${({ theme }) => theme.colors.shadow.soft};
`

export const StyledPicName = styled.p`
  text-align: center;
  font-size: clamp(1.1rem, 2.1vw, 1.4rem);
  font-family: ${({ theme }) => theme.fonts.title.lineTwo};
  text-transform: capitalize;
  letter-spacing: 0.04em;
  color: ${({ theme }) => theme.colors.palette.secondary};
  padding: 0 10px 10px;
  margin: 0 auto;

  @media (max-width: ${({ theme }) => theme.screen.small}) {
    font-size: 1.1rem;
  }
`

export const StyledPicImg = styled(motion.img)<{
  $side:SlideInDirection,
}>`
  display: block;
  padding: 8px;
  margin: auto;
  border-radius: 20px;
  width: 100%;
  max-width: 300px;
  height: 320px;
  object-fit: cover;
  border: 1px solid ${({ theme }) => theme.colors.border.soft};
  box-shadow: 0 10px 22px ${({ theme }) => theme.colors.shadow.soft};
  transform-origin: ${({ $side }) => {
    return ($side === SlideInDirection.left)
      ? 'left center'
      : 'right center'
  }};
`

export const StyledControlsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 0.5em;
  background-color: ${({ theme }) => theme.colors.lighten.primary};
  box-shadow: 0 0 6px 4px ${({ theme }) => theme.colors.lighten.primary};
  text-align: center;
  color: ${({ theme }) => theme.colors.palette.secondary};
  padding: 0 10px;
  margin: 0.85rem auto 0;
  width: 80%;
  height: 1.9em;
  border-radius: 0.9em;
`

export const StyledQuantity = styled.span`
  display: inline-block;
  width: 2ch;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  vertical-align: middle;
`

export const StyledButton = styled(motion.button)`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 0.9em;
  height: 1.9em;
  width: 1.9em;
  color: ${({ theme }) => theme.colors.palette.secondary};
  background-color: ${({ theme }) => theme.colors.palette.primary};

  &:hover {
    box-shadow: 0 0 4px 2px ${({ theme }) => theme.colors.palette.primary};
  }
`
